import JsxParser from 'react-jsx-parser'
import moment from 'moment'
import { GridRenderCellParams } from '@microservices/wiskey-react-table-component'
import { Box } from '@mui/material'

import { renderJSValueCell } from '@helpers'
import { BIND_TYPE, TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME } from '@constants'
import { ObjectDataRecord, TimeLineDTOType } from '@types'

import { groupTitleCellRenderer } from './group/groupTitleCellRenderer'
import { isGroupTitleRow } from './isGroupTitleRow'

export const objectXCellRenderer = (data: {
  config: TimeLineDTOType
  params: GridRenderCellParams
  cellItem: ObjectDataRecord
  cellItemIndex: number
}) => {
  const { config, params, cellItem, cellItemIndex } = data

  const source = {
    row: params.row,
    valueKey: params.field,
    moment,
    value: params.value,
    cellItem,
    cellItemIndex,
    cellWidth: params.colDef.computedWidth,
    cellHeight: config.objectX.cell?.minHeight / params.value?.length,
  }

  if (isGroupTitleRow(params.id as string)) {
    return groupTitleCellRenderer({ params, config })
  }

  if (config.objectX.cell?.bindType === BIND_TYPE.JS) {
    return renderJSValueCell(config.objectX.cell.value, source)
  }

  if (config.objectX.cell?.bindType === BIND_TYPE.JSX) {
    return (
      <div style={{ pointerEvents: 'none', width: '100%', height: '100%' }}>
        {/* eslint-disable-next-line */}
        {/* @ts-ignore */}
        <JsxParser
          className={TIME_LINE_DATE_INTERVAL_CELL_JSX_PARSER_CLASS_NAME}
          jsx={config.objectX.cell.value}
          bindings={{
            srcObj: source,
            Object,
            Array,
            Math,
            moment,
          }}
        />
      </div>
    )
  }

  return (
    <Box
      style={{
        height: '100%',
        width: '100%',
        backgroundColor: '#C9E7DD',
      }}
    />
  )
}
